module.exports = __webpack_public_path__ + "img/810.93042012.gif";